import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import FailedTabsContent from '../components/FailedTabsContent';
interface FailedTabsProps {
  onLogout: () => void;
}
export default function FailedTabs({
  onLogout
}: FailedTabsProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    overflow: 'hidden'
  }} data-id="element-3566" data-mp="2g9snmizmzxsx">
      
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Failed Transactions" data-id="element-3567" data-mp="38y7qk75hupnw" />
      
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="failed-tabs" data-id="element-3568" data-mp="3drssgaa7k3sd" />
      
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: {
        xs: 2,
        sm: 3,
        md: 5
      },
      width: {
        xs: '100%',
        sm: 'calc(100% - 240px)'
      },
      maxWidth: '100%',
      ml: 0,
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-3569" data-mp="2fwvkcwd1tevr">
        
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-3570" data-mp="33okfekh98hge">
          
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-3571" data-mp="2yn4vivqtcgzl">
            
            <Icon icon="lucide:folder-kanban" width={28} height={28} color="#EF4444" data-id="element-3572" data-mp="38l153j43r3vl" />
            
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-3573" data-mp="1ib7l83p7kigj">
              
              Failed Transactions
            </Typography>
          </Box>
          <FailedTabsContent data-id="element-3574" data-mp="3icfi7hbkhof4" />
        </Box>
      </Box>
    </Box>;
}